








import { Component, Mixins, Prop, Ref } from 'vue-property-decorator'
import VhFixMixin from '@/plugins/mixins-vh-fix'
import { Company } from '@/api/model/company'
import { Question } from '@/views/Form/Conversation.vue'
import Conversation from '@/views/Form/Conversation.vue'
const basePath = process.env.VUE_APP_KEYVUE_BACKEND_BASEPATH || ''

@Component({
    components: {
        Conversation,
    },
})
export default class ExampleForm extends Mixins(VhFixMixin) {
    @Prop() company!: Company
    @Ref() example!: Conversation

    get types(): object[] {
        return [
            {
                label: 'Tekst invoer',
                value: 'text',
            },
            {
                label: 'Keuzemenu met tekst invoer',
                value: 'choice',
            },
            {
                label: 'Selectie menu',
                value: 'multi-choice',
            },
        ]
    }

    get questions(): Question[] {
        const questions: Question[] = [
            {
                question: `Hoi! Ik ben Emma van ${this.company.branding.displayName}. Ik ben het voorbeeld hoe jouw chat eruit komt te zien! Waar wil je een voorbeeld van zien?`,
                model: 'type',
                input: 'choice',
                inputAttrs: {
                    name: 'Tenminste één type',
                    options: this.types,
                },
            },
        ]

        if (this.answers.type === 'text') {
            questions.push(
                {
                    question: `Dit is het tekstveld voorbeeld, ga verder om een nieuw voorbeeld te kiezen!`,
                    model: 'answer',
                    afterLeave: async (): Promise<void>  => {
                        this.example.reset()
                        this.answers = {
                            type: null,
                            answer: null,
                        }
                    },
                },
            )
        }

        if (this.answers.type === 'choice') {
            questions.push({
                question: `Dit is het keuzemenu voorbeeld, ga verder om een nieuw voorbeeld te kiezen!`,
                model: 'answer',
                input: 'text',
                inputAttrs: {
                    name: 'Knoppen',
                },
                choices: [
                    'Ik ga wellicht verkopen (Binnen 3 maanden)',
                    'Ik ga wellicht verkopen (Binnen 6 maanden)',
                    'Ik ga wellicht verkopen (Binnen 12 maanden)',
                    'Ik ben gewoon nieuwsgierig',
                    'Ik ben benieuwd ivm WOZ waarde',
                ],
                afterLeave: async (): Promise<void>  => {
                    this.example.reset()
                    this.answers = {
                        type: null,
                        answer: null,
                    }
                },
            })
        }

        if (this.answers.type === 'multi-choice') {
            questions.push({
                question: `Dit is het multiple choice voorbeeld, ga verder om een nieuw voorbeeld te kiezen!`,
                model: 'answer',
                input: 'multi-choice',
                inputAttrs: {
                    name: 'Teminste 1 keuze maken',
                    options: [
                        {
                            label: 'optie 1',
                            value: 'optie-1',
                        },
                        {
                            label: 'optie 2',
                            value: 'optie-2',
                        },
                        {
                            label: 'optie 3',
                            value: 'optie-3',
                        },
                    ],
                },
                afterLeave: async (): Promise<void>  => {
                    this.example.reset()
                    this.answers = {
                        type: null,
                        answer: null,
                    }
                },
            })
        }

        return questions
    }

    answers = {
        type: null,
        answer: null,
    }
}
